(function() {
    'use strict';
    
a3_cabin_reports.controller('ResetDeviceCtrl',ResetDeviceCtrl);
    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name ResetDeviceCtrl
    * @description 
    *  Manage Reset view
    * @ngInject
    */ 
function ResetDeviceCtrl($location, $scope, DataCleanerFactory, UserFactory) {

		$scope.isSecure = UserFactory.isSecure();

		// show logged user info
		var user = UserFactory.getUser();
		$scope.logged_user_info = "-user has not logged in-";
		if (user)
			$scope.logged_user_info = user.aimsId + ' - ' + user.name;

		$scope.resetDevice = resetDevice;
        $scope.cancelReset = cancelReset;   
            
        /**
        * Reset Device storage
        * @memberof ResetDeviceCtrl
        */
        function resetDevice() {
			DataCleanerFactory.deleteAllData();
			bootbox.alert("Your device has been reset.", function() {
				$location.path("/login");
				$scope.$apply();
			});
		}
            
        /**
        * Cancel Reset and go to main page.
        * @memberof ResetDeviceCtrl
        */
        function cancelReset() {
			$location.path("/");
		}

	}

})();